import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../utils/apiUrl";
import { masterAuth } from "./masterApi";

export default function MasterLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const res = await fetch(`${API_URL}/api/master/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Login failed");
      masterAuth.saveToken(data.token);
      nav("/master");
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      data-testid="master-login"
      style={{
        minHeight: "100vh",
        background: "radial-gradient(ellipse at top, #1a0b2e 0%, #050309 60%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        color: "#e9e6f2",
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: "min(420px, 92vw)",
          background: "rgba(20, 12, 35, 0.65)",
          border: "1px solid #3a2a55",
          padding: "44px 36px",
          borderRadius: 18,
          boxShadow: "0 30px 80px -10px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.03) inset",
          backdropFilter: "blur(18px)",
        }}
      >
        <div style={{ fontSize: 11, letterSpacing: 3, opacity: 0.5, marginBottom: 6 }}>
          PLATFORM CONTROL
        </div>
        <h1 style={{ fontSize: 28, margin: "0 0 4px", letterSpacing: -0.5 }}>
          Master Console
        </h1>
        <div style={{ fontSize: 13, opacity: 0.55, marginBottom: 28 }}>
          Sign in to manage tenants
        </div>

        <label style={{ fontSize: 11, opacity: 0.7, textTransform: "uppercase", letterSpacing: 1.5 }}>
          Email
        </label>
        <input
          data-testid="master-email-input"
          type="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={{ fontSize: 11, opacity: 0.7, textTransform: "uppercase", letterSpacing: 1.5, marginTop: 14, display: "block" }}>
          Password
        </label>
        <input
          data-testid="master-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={inputStyle}
        />

        {err && (
          <div data-testid="master-login-error" style={{ marginTop: 14, padding: "10px 12px", background: "rgba(255,80,90,0.1)", border: "1px solid rgba(255,80,90,0.4)", color: "#ff7886", fontSize: 13, borderRadius: 8 }}>
            {err}
          </div>
        )}

        <button
          data-testid="master-login-submit"
          type="submit"
          disabled={busy}
          style={{
            marginTop: 22,
            width: "100%",
            padding: "12px 16px",
            background: busy ? "#3a2a55" : "linear-gradient(135deg, #8b5cf6, #a855f7)",
            color: "white",
            border: "none",
            borderRadius: 10,
            fontWeight: 600,
            fontSize: 14,
            letterSpacing: 0.5,
            cursor: busy ? "wait" : "pointer",
            transition: "transform 120ms ease, box-shadow 120ms ease",
            boxShadow: "0 12px 28px -10px rgba(139, 92, 246, 0.6)",
          }}
          onMouseDown={(e) => (e.currentTarget.style.transform = "translateY(1px)")}
          onMouseUp={(e) => (e.currentTarget.style.transform = "translateY(0)")}
        >
          {busy ? "…" : "Enter Console"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  marginTop: 6,
  padding: "12px 14px",
  background: "rgba(255,255,255,0.03)",
  border: "1px solid #3a2a55",
  borderRadius: 10,
  color: "#fff",
  fontSize: 14,
  fontFamily: "inherit",
  outline: "none",
  transition: "border-color 120ms ease",
};
